import React, { useContext, useState } from 'react';
import UserHeatmap from '../components/Heatmap/UserHeatmap';
import Leaderboard from '../components/Heatmap/Leaderboard';
import { AuthContext } from '../context/AuthContext';
import './ActivityDashboard.css';

export default function ActivityDashboard() {
  const { user, token } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('heatmap');

  if (!user || !token) {
    return (
      <div className="activity-dashboard">
        <div className="access-denied">
          <h2>Access Denied</h2>
          <p>Please log in to view your activity dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="activity-dashboard">
      <div className="dashboard-header">
        <h1>Activity Dashboard</h1>
        <p>Track your productivity and compare with team members</p>
      </div>

      <div className="dashboard-tabs">
        <button
          className={`tab-btn ${activeTab === 'heatmap' ? 'active' : ''}`}
          onClick={() => setActiveTab('heatmap')}
        >
          My Heatmap
        </button>
        <button
          className={`tab-btn ${activeTab === 'leaderboard' ? 'active' : ''}`}
          onClick={() => setActiveTab('leaderboard')}
        >
          Leaderboard
        </button>
      </div>

      <div className="dashboard-content">
        {activeTab === 'heatmap' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Your Activity Heatmap</h2>
              <p>Visualize your daily activity patterns and streaks</p>
            </div>
            <UserHeatmap userId={user._id} token={token} />
          </div>
        )}

        {activeTab === 'leaderboard' && (
          <div className="tab-content">
            <div className="content-header">
              <h2>Team Leaderboard</h2>
              <p>See how you rank among your colleagues</p>
            </div>
            <Leaderboard token={token} userRole={user.role} />
          </div>
        )}
      </div>

      <div className="dashboard-info">
        <div className="info-card">
          <h3>How It Works</h3>
          <p>Your activity is automatically tracked based on:</p>
          <ul>
            <li><strong>Login:</strong> +1 point per day</li>
            <li><strong>Updates:</strong> +3 points per action</li>
            <li><strong>File Uploads:</strong> +5 points per file</li>
            <li><strong>Task Completion:</strong> +8 points per task</li>
            <li><strong>Admin Actions:</strong> +10 points per action</li>
          </ul>
        </div>

        <div className="info-card">
          <h3>Tips for Higher Scores</h3>
          <ul>
            <li>Complete tasks regularly throughout the day</li>
            <li>Upload and organize documents</li>
            <li>Participate in team discussions</li>
            <li>Update project information promptly</li>
            <li>Maintain consistent daily activity</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
